var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionheaderPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8581_14299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.25H4V4C4 2.06953 5.56953 0.5 7.5 0.5H20.0508C20.9805 0.5 21.8719 0.866406 22.5281 1.52266L23.9773 2.97187C24.6336 3.62812 25 4.51953 25 5.44922V9.25H23.25V5.44922C23.25 4.98438 23.0641 4.54141 22.7359 4.21328L21.2867 2.76406C20.9586 2.43594 20.5156 2.25 20.0508 2.25H7.5C6.53203 2.25 5.75 3.03203 5.75 4V9.25ZM25 12.75H4C3.03203 12.75 2.25 13.532 2.25 14.5V21.5H4V19.75C4 18.782 4.78203 18 5.75 18H23.25C24.218 18 25 18.782 25 19.75V21.5H26.75V14.5C26.75 13.532 25.968 12.75 25 12.75ZM25 23.25V26.75C25 27.718 24.218 28.5 23.25 28.5H5.75C4.78203 28.5 4 27.718 4 26.75V23.25H2.25C1.28203 23.25 0.5 22.468 0.5 21.5V14.5C0.5 12.5695 2.06953 11 4 11H25C26.9305 11 28.5 12.5695 28.5 14.5V21.5C28.5 22.468 27.718 23.25 26.75 23.25H25ZM5.75 19.75V26.75H23.25V19.75H5.75ZM24.125 14.0625C24.4731 14.0625 24.8069 14.2008 25.0531 14.4469C25.2992 14.6931 25.4375 15.0269 25.4375 15.375C25.4375 15.7231 25.2992 16.0569 25.0531 16.3031C24.8069 16.5492 24.4731 16.6875 24.125 16.6875C23.7769 16.6875 23.4431 16.5492 23.1969 16.3031C22.9508 16.0569 22.8125 15.7231 22.8125 15.375C22.8125 15.0269 22.9508 14.6931 23.1969 14.4469C23.4431 14.2008 23.7769 14.0625 24.125 14.0625Z",
    fill: "#0D2EA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8581_14299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionheaderPrintIcon);
export default __webpack_public_path__ + "static/media/sectionheader-printIcon.6584f8f8fbcd5cb147ffe531f00f2ab5.svg";
export { ForwardRef as ReactComponent };